import { Typography } from "@mui/material";

export default function CervinoText({ sx, ...props }) {
    return <Typography {...props} sx={{ ...sx }} />;
}
